var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.394 0c-10.562 2.001-18.18 11.397-18.007 22.272v66.816c0.087 5.742 2.251 11.222 6.233 15.312l348.373 371.659v392.542c0.173 7.739 4.416 14.877 11.082 18.79l221.629 133.632c6.753 3.913 15.15 4.001 21.99 0.080 6.753-3.825 11.082-11.045 11.254-18.878v-526.166l348.371-371.659c1.039-1.044 1.989-2.262 2.772-3.48 0.519-0.435 0.951-0.87 1.382-1.392 1.302-2.871 1.997-5.916 2.077-9.048v-1.392c0.088-1.132 0.088-2.349 0-3.48v-63.335c0-12.267-9.955-22.272-22.162-22.272h-934.994zM68.712 44.543h886.513v36.192l-342.137 364.7h-202.236l-342.14-364.7v-36.192zM600.622 489.978v473.277l-177.303-106.489v-366.788h177.303z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.86595a338f20053155c6b60dfa0610e8.svg";
export { ForwardRef as ReactComponent };